import darkLogo from "../../assets/bmt-logo-dark.png";
import lightLogo from "../../assets/bmt-logo-light.png";
import { cn } from "../../lib/utils";

type LogoProps = {
  variant?: "dark" | "light";
  className?: string;
  priority?: boolean;
};

/** Official wordmark, used as supplied (dark or light variant). */
export function Logo({ variant = "dark", className, priority = false }: LogoProps) {
  const asset = variant === "dark" ? darkLogo : lightLogo;
  return (
    <img
      src={asset}
      alt="Billionaire Mindset Technologies"
      width={1536}
      height={variant === "dark" ? 427 : 453}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      className={cn("h-auto w-full object-contain", className)}
    />
  );
}
